module.exports = __webpack_public_path__ + "static/media/gilroy.06c8bcd8.woff2";